// @flow
import * as React from 'react'

import './H2.scss'

type Props = {
  children: React.Node,
}

export default class H2 extends React.Component<Props> {
  render = () => {
    return <div className="H2">{this.props.children}</div>
  }
}
